import { SET_SELECTED_USER_ID, GET_USERS_LIST } from './types';

export const setSelectedUserId = (userId) => {
  return {
    type: SET_SELECTED_USER_ID,
    payload: userId
  };
};

/**
 * @desc Set Users dispatch service
 * @param {*} users
 */
export const setUserList = (users) => {
  return {
    type: GET_USERS_LIST,
    payload: users
  };
};
